import { render, staticRenderFns } from "./ArticleInfo.vue?vue&type=template&id=b9ab7b82&"
import script from "./ArticleInfo.vue?vue&type=script&lang=js&"
export * from "./ArticleInfo.vue?vue&type=script&lang=js&"
import style0 from "./ArticleInfo.vue?vue&type=style&index=0&id=b9ab7b82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports